import { Notification } from '../../../../../models/Notification'
import { StylesScene } from '../../../../../models/Story'
import { getNotificationImgPathes } from '../../resolveImgPath'

type TUserAddItemStyles = {
    [key: string]: StylesScene
}
const UserAddItemStyles: TUserAddItemStyles = {
    'Group': {
        staticTextNewItemGroup: {
            container: {
                position: 'absolute',
                top: 130,
                right: 61,
            },
            text: {
                textShadow: '0 2px 6px rgba(0, 0, 0, 0.25)',
                fontSize: 48,
                fontWeight: 'bold',
                lineHeight: 1.21,
                letterSpacing: '-0.01px',
                textAlign: 'center',
                color: '#f9cd1b',
            }
        },
        groupTitleCollection: {
            container: {
                top: 238,
                left: 141,
            },
            text: {
                fontFamily: 'Roboto Slab',
                fontSize: 20,
                fontWeight: 'bold',
                color: '#000',
            }
        },
        groupImg: {
            container: {
                width: 280,
                height: 231,
                position: 'absolute',
                top: 262,
                left: 0,
            }
        },
        dataTypeTag: {
            container: {
                position: 'absolute',
                top: 317,
                right: 31,
            },
            text: {
                opacity: 0.8,
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                fontFamily: 'Roboto Slab',
                fontSize: 24,
                fontWeight: 800,
                lineHeight: 2.33,
                letterSpacing: 0.5,
                color: '#ffd288',
            }
        },
        dataTypeTitle: {
            container: {
                position: 'absolute',
                top: 365,
                right: 17
            },
            text: {
                opacity: 0.75,
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                fontFamily: 'Roboto Slab',
                fontSize: 20,
                fontWeight: 800,
                lineHeight: 2.8,
                letterSpacing: 0.5,
                color: '#fff',
                textTransform: 'uppercase'
            }
        },
        docTitle: {
            container: {
                position: 'absolute',
                top: 481,
                left: 24,
                zIndex: 3,
                borderRadius: 4,
                background: 'black',
                padding: '12px 15px',
                transform: 'rotate(-10deg)',
                maxHeight: 118,
                maxWidth: 442,
            },
            text: {
                fontSize: 40,
                fontWeight: 'bold',
                color: '#fff',
                lineHeight: 1.3,
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                letterSpacing: 0,
            }
        },
        mainImg: {
            container: {
                position: 'absolute',
                zIndex: 1,
                bottom: 0,
                right: 0,
                boxSizig: 'border-box',
                border: '8px solid #fff',
                width: 360,
                height: 280
            }
        }
    },
    'Public': {
        docTitle: {
            container: {
                position: 'absolute',
                top: 492,
                right: 12,
                maxHeight: 118,
                maxWidth: 442,
            },
        },
        dataType: {
            container: {
                top: 660,
                right: 90,
                position: 'absolute',
            }
        },
        dataTypeTitle: {
            container: {
                top: 720,
                right: 25,
                position: 'absolute',
            }
        },
        mainImg: {
            container: {
                width: 360,
                height: 280,
                position: 'absolute',
                top: 256,
                right: 98,
            }
        }
    }
}
export const getUserAddItemBackground = (notif: Notification): [string, StylesScene] => {
    return [getNotificationImgPathes(notif.systemActionTypeUid)[notif.groupType], UserAddItemStyles[notif.groupType]]
}